/* eslint-disable @typescript-eslint/camelcase */
import { FlagsPermissionBooking } from "@/feature-flags/flag-booking";
import { ShipmentId } from "./Booking";
import { EstimationPrice } from "./Booking";
import { CommodityData, ClientData } from "./BulkBooking";
import { DetailCodConfigurationRetail } from "./CodConfiguration";
import { HeavyWeightSurchargeData } from "./HeavyWeightSurcharge";
import { Insurance } from "./Insurance";
import { CountryData, DistrictData } from "./Location";
import { OptionsClass } from "./MainApp";
import { ProductConfigurationRuleList } from "./Product";
import { Discount } from "./PromoConfiguration";
import { FlagsPermissionBookingV3 } from "@/feature-flags/flag-booking-v3";

// entities create booking v3
export class DestinationCity {
  id = 0;
  cityId = 0;
  name = "";
  status = "";
  code = "";
  cityCode = "";
  vendorCode = "";
  type = "";
  isCod = "";
  countryCode = "";
  countryName = "";
  postalCode = "";
  constructor(fields?: Partial<DestinationCity>) {
    Object.assign(this, fields);
  }
}

export const FraudStatus = {
  LIMITED: "limited",
  SUSPECTED: "suspected"
} as const;

export const BookingFormType = {
  CLIENT: "client",
  MANUAL: "manual"
} as const;

export const AddressType = {
  rumah: "home",
  kantor: "office"
} as const;

export const ConfigValidationForm = {
  EDITABLE: "EDITABLE",
  NON_EDITABLE: "NON_EDITABLE",
  SHOW: "SHOW",
  NON_SHOW: "NON_SHOW"
} as const;

export class CommodityBookingV3 {
  id = 0;
  name = "";
  code = "";
  isDangerousGoods = false;
  isQuarantine = false;
  status = "";
  isNotFound = false;

  constructor(fields?: Partial<CommodityBookingV3>) {
    Object.assign(this, fields);
  }
}

export class PosterProduct {
  cityRates = 0;
  forwardRates = 0;
  grossWeight = 0;
  volumeWeight = 0;
  chargeableWeight = 0;
  shippingCost = 0;
  commoditySurcharge = 0;
  heavyWeightSurcharge = 0;
  documentSurcharge = 0;
  insuranceRates = 0;
  insuranceName = "";
  insuranceLabel = "";
  insuranceAdminFee = 0;
  woodpackingRates = 0;
  totalTariff = 0;
  taxRates = 0;
  bmTaxRate = 0;
  ppnTaxRate = 0;
  pphTaxRate = 0;
  originDistrictRate = 0;
  destinationDistrictRate = 0;
  publishRate = 0;
  shippingSurchargeRate = 0;
  productType = "";
  heavyWeightSurchargeRemarks = "";
  estimateSla = "";
  codAmount = 0;
  roundingDiff = 0;
  codFee = 0;
  padFee = 0;
  codBookingDiscount = 0;
  currency = "";
  isDiscountExceedMaxPromo = false;
  isPromo = false;
  discountType = "";
  discount = 0;
  maximalPromo = 0;
  parameterCalculation = "";
  totalDiscount = 0;
  publishRateAfterDiscount = 0;
  shippingSurchargeRateAfterDiscount = 0;
  originDistrictRateAfterDiscount = 0;
  destinationDistrictRateAfterDiscount = 0;
  documentSurchargeAfterDiscount = 0;
  commoditySurchargeAfterDiscount = 0;
  heavyWeightSurchargeAfterDiscount = 0;
  woodpackingRatesAfterDiscount = 0;
  insuranceRatesAfterDiscount = 0;
  codFeeAfterDiscount = 0;
  totalTariffAfterDiscount = 0;
  listDiscount = [];
  bookingCommission = 0;
  commissionRate = 0;
  commissionType = "";
  isEmbargo = false;
  isRecommended = false;
  statusActive = false;
  isMasking = false;

  constructor(fields?: Partial<PosterProduct>) {
    Object.assign(this, fields);
  }
}

export class ProductTypePoster {
  name = "";
  estimateSla = "";
  totalTariffAfterDiscount = 0;
  commissionRate = 0;
  bookingCommission = 0;
  isEmbargo = false;
  isRecommended = false;
  statusActive = false;
  shippingCost = 0;
  isMasking = false;

  constructor(fields?: Partial<ProductTypePoster>) {
    Object.assign(this, fields);
  }
}

export class ModelStt {
  value = "";
  isAllowBooking = false;

  constructor(fields?: Partial<ModelStt>) {
    Object.assign(this, fields);
  }
}

export class DocInternationalModelValueType {
  listCommodityCIPL: CommodityCIPL[] = [];
  email = "";
  idNumber = "";
  taxNumber = "";
  dutyTaxTerms = "";
  dgType = "";
  quarantineType = "";
  imageBeforePackingUrl = "";
  imageAfterPackingUrl = "";
  imageIdUrl = "";
  imageTaxUrl = "";
  shipmentStatus = new OptionsClass();

  constructor(fields?: Partial<DocInternationalModelValueType>) {
    Object.assign(this, fields);
  }
}

export class BookingV3 {
  sender = "";
  sttNo = "";
  phoneFlagSender = "";
  phoneCodeSender = "+62";
  phoneSender = "";
  addressSender = "";
  isSaveSender = false;
  originCountry = new CountryData();
  receiver = "";
  phoneFlagReceiver = "";
  phoneCodeReceiver = "+62";
  phoneReceiver = "";
  addressReceiver = "";
  addressReceiverType = new OptionsClass({
    value: AddressType.rumah
  });
  destinationCity: string | DistrictData = "";
  postalCodeDestination: string | DistrictData = "";
  isSaveReceiver = false;
  destinationCountry = new CountryData();
  accountIsNonForeign = false;
  sttManual = "";
  referenceExternal = "";
  checkoutPaymentMethod = "";
  shipmentId = "";
  commodityCode = new CommodityBookingV3();
  isCOD = false;
  isDFOD = false;
  productName = "";
  isVendorNinjaDestination = false;
  destinationIsEmbargo = false;
  destinationIsUnavailable = false;
  commodity = new OptionsClass();
  woodpacking = false;
  serviceType = "non-cod";
  estimationPrice = "";
  codAmount = "";
  insurance = "basic";
  clientName = new ClientData();
  sttShipmentId = "";
  pieces: any[] = [];
  ftzForm = new DocInternationalModelValueType();
  docInternationalForm = new DocInternationalModelValueType();
  sttPiecePerPack = "";
  sttNextCommodity = "";
  adjustmentWeightAttachments: string[] = [];
  bookedForCountry = "";

  constructor(fields?: Partial<BookingV3>) {
    Object.assign(this, fields);
  }

  get sttIsCod() {
    return this.serviceType === "cod";
  }

  set sttIsCod(val: boolean) {
    if (!val) {
      this.serviceType = "non-cod";
      this.isCOD = false;
      this.isDFOD = false;
    } else {
      this.serviceType = "cod";
      this.isCOD = true;
    }
  }

  get sttIsDfod() {
    return this.serviceType === "dfod";
  }

  set sttIsDfod(val: boolean) {
    if (!val && this.sttIsCod) {
      this.serviceType = "cod";
      this.isCOD = true;
      this.isDFOD = false;
    }
    if (!val && !this.sttIsCod) {
      this.serviceType = "non-cod";
      this.isCOD = false;
      this.isDFOD = false;
    }
    if (val && this.sttIsCod) {
      this.serviceType = "dfod";
      this.isCOD = true;
      this.isCOD = true;
    }
  }
}

export class ErrorBookingV3 {
  [x: string]: any;
  sender = "";
  phoneSender = "";
  isSaveSender = "";
  accountIsNonForeign = "";
  addressSender = "";
  receiver = "";
  phoneReceiver = "";
  addressReceiver = "";
  destinationCity = "";
  postalCode = "";
  emailDocInternational = "";
  idNumberDocInternational = "";
  taxNumberDocInternational = "";
  dutyTaxTermsDocInternational = "";
  listCommodityCIPLDocInternational: string[][] = [];
  idImageDocInternational = "";
  taxImageDocInternational = "";
  packageBeforePackingImageDocInternational = "";
  packageAfterPackingImageDocInternational = "";
  referenceNumber = "";
  sttManual = "";
  commodity = "";
  client = "";

  constructor(fields?: Partial<ErrorBookingV3>) {
    Object.assign(this, fields);
  }
}

export class CustomerBookingV3 {
  customerAddress = "";
  customerId = 0;
  customerName = "";
  customerPhoneCode = "";
  customerPhoneNumber = "";
  customerPhoneflag = "";
  customerCommodityCode = "";
  customerDistrictId = 0;
  customerAddressType = "";
  countryCode = "";

  constructor(fields?: Partial<CustomerBookingV3>) {
    Object.assign(this, fields);
  }
}
export class CommodityCIPL {
  id = 0;
  indexCommodity = 0;
  indexQuantity = 0;
  indexGoodsPrice = 0;
  name = "";
  quantity = "";
  goodsPrice = "";
  commodity: CommodityData = new CommodityData();
  num? = 0;

  constructor(fields?: Partial<CommodityCIPL>) {
    Object.assign(this, fields);
  }
}

export class PhoneBookingV3 {
  code = "";
  phone = "";
  flag = "";
  name = "";
  nationalPrefix = "";

  constructor(fields?: Partial<PhoneBookingV3>) {
    Object.assign(this, fields);
  }
}

export class DetailDiscount {
  pdcId = 0;
  pdcName = "";
  pdcPromoDiscount = 10;
  pdcCategory = "";
  pdcEndDate = "";
  pdcDiscountAmount = 0;
  pdcQuantifier = "";

  constructor(fields?: Partial<DetailDiscount>) {
    Object.assign(this, fields);
  }
}

export class STT {
  sttNo = "";
  sttId = 0;
  isDiscount = false;
  totalDiscount = 0;
  totalAfterDiscount = 0;
  totalBeforeDiscount = 0;
  destinationCityCode = "";
  originCityCode = "";
  productType = "";
  commodityGroupCode = "";
  chargeableWeight = 0;
  isCod = false;
  isDfod = false;
  codAmount = 0;
  sttCodAmount = 0;
  endSla = "";
  sttRecipientName = "";
  sttDestinationDistrictName = "";
  listDiscount: DetailDiscount[] = [];

  constructor(fields?: Partial<STT>) {
    Object.assign(this, fields);
  }
}

export class SuccessBooking {
  stt: STT[] = [];
  listDiscount: DetailDiscount[] = [];
  recipientName = "";
  destinationCityName = "";
  destinationDistrictName = "";
  estimateSla = "";
  estimationDate = "";
  codAmount = 0;
  codFee = 0;
  isCod = false;
  isDfod = false;
  shipmentId = "";
  paymentMethodLabel = "";
  sttPaymentMethod = "";

  constructor(fields?: Partial<SuccessBooking>) {
    Object.assign(this, fields);
  }
}

export class AdvancedFilterData {
  periodeStart = "";
  periodeEnd = "";
  originCode = "";
  destinationCode = "";
  clientPartnerId = "";
  clientPartner = "";
  clientPartnerName = "";
  status = "";
  product: string[] = [];
  COD = false;
  PAD = false;
  DFOD = false;
  asuransi: string[] = [];
  cityOriginCode = "";
  cityDestinationCode = "";
  phoneReceiver = "";
  phoneSender = "";
  nestedStatus: string[] = [];
  districtId = "";

  constructor(fields?: Partial<AdvancedFilterData>) {
    if (fields) {
      Object.assign(this, fields);
    }
  }
}

export class AdvancedFilterFormData {
  origin: any = "";
  destination: any = "";
  client: any = "";
  status = "";
  airport = "";
  commodity = "";

  constructor(fields?: Partial<AdvancedFilterFormData>) {
    if (fields) {
      Object.assign(this, fields);
    }
  }
}

export class ShipmentIdTable extends ShipmentId {
  id = 0;
  no = 0;
  isDeleted = false;
  isInstant = false;
  isLoading = false;
  error: null | string = null;
  bookingStatus: BookingStatus = "belum_dibooking";
  groupId = "";

  constructor(fields?: Partial<ShipmentIdTable>) {
    super();
    Object.assign(this, fields);
  }
}

export class BookingMasterData {
  productList = [] as string[];
  upsellingList = [] as PosterProduct[];
  tarifEstimation = new EstimationPrice();
  codActiveConfig = new DetailCodConfigurationRetail();
  dfodActiveConfig = new DetailCodConfigurationRetail();
  hwsConfig = new HeavyWeightSurchargeData();
  productConfig = new ProductConfigurationRuleList();
  insuranceConfig = new Insurance();
  maxPieces = 15;
  discount = new Discount();

  constructor(fields?: Partial<BookingMasterData>) {
    if (fields) {
      Object.assign(this, fields);
    }

    this.productList = FlagsPermissionBookingV3.config_upselling_product_list.getValue().shipment;

    if (!FlagsPermissionBooking.config_show_bigpack_fast.isEnabled) {
      this.productList = this.productList.filter(
        (product) => product !== "BIGPACKFAST"
      );
    }
  }
}

export class SubmittedTokenSnapshot {
  tokens: string[] = [];
  batchId = "";
  submittedAt = "";

  constructor(fields?: Partial<SubmittedTokenSnapshot>) {
    Object.assign(this, fields);
  }
}

export type BookingStatus =
  | "belum_dibooking"
  | "berhasil_dibooking"
  | "gagal_dibooking";

export type ScanTokenOutcome = "resolved" | "not_found";

export class ScanLogEntry {
  shipmentNumber = "";
  reason = "";
  occurredAt = "";

  constructor(fields?: Partial<ScanLogEntry>) {
    Object.assign(this, fields);
  }
}

export class AggregateFilterSort {
  isSuccessBooking = false;
  isNotBooked = false;
  isFailedBooking = false;
  isAscending = false;

  constructor(fields?: Partial<AggregateFilterSort>) {
    Object.assign(this, fields);
  }
}

export class ScanTokenMember {
  detail = new ShipmentIdTable();
  isApAs = false;

  constructor(fields?: Partial<ScanTokenMember>) {
    Object.assign(this, fields);
  }
}

export class ScanTokenResult {
  outcome: ScanTokenOutcome = "not_found";
  members: ScanTokenMember[] = [];

  constructor(fields?: Partial<ScanTokenResult>) {
    Object.assign(this, fields);
  }
}

// CP (corporate package) group metadata, keyed by canonical shipmentAlgoId.
// Kept separate from ShipmentIdTable row fields per GENESIS-22409 — group
// metadata (client/eligibility/balance) does not belong to any single row.
export class CpShipmentGroupMetadata {
  shipmentAlgoId = "";
  clientIdBranch = 0;
  clientRef = "";
  latestStatus = "";
  actualTotalPieces = 0;
  bookedTotalPieces = 0;
  remainingPieces = 0;

  constructor(fields?: Partial<CpShipmentGroupMetadata>) {
    Object.assign(this, fields);
  }
}

export class BookingAggregateState {
  submittedTokenSnapshot: SubmittedTokenSnapshot | null = null;
  shipmentRows: ShipmentIdTable[] = [];
  log: ScanLogEntry[] = [];
  filterSort = new AggregateFilterSort();
  bookingInstanConsent = false;
  skipSet = new Set<string>();
  isBatchRunning = false;
  cpGroupMetadata: Record<string, CpShipmentGroupMetadata> = {};

  constructor(fields?: Partial<BookingAggregateState>) {
    if (fields) {
      Object.assign(this, fields);
    }
  }
}

export function createDefaultBookingAggregateState(): BookingAggregateState {
  return new BookingAggregateState();
}
